import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import {createStore, applyMiddleware, compose} from 'redux'
import thunk from 'redux-thunk';

import App from './App';
import Reducers from './redux/rootReducer';

const store = createStore(Reducers, compose(applyMiddleware(thunk)));

ReactDOM.render(
    <Provider store = {store}>   
    <App />
    </Provider>, 
    document.getElementById("root")
);